"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendClickstreamLog = exports.CommonAnalyticsInterface = void 0;
var clickstream_1 = require("@airtel-web/clickstream");
var clickstream_2 = require("@airtel-web/clickstream");
var AnalyticsInterface = /** @class */ (function () {
    function AnalyticsInterface() {
        clickstream_1.init;
    }
    AnalyticsInterface.prototype.sendClickstreamLog = function (logPayLoad) {
        logPayLoad.prop0 = 'omni-serviceability';
        if (window.ClickStream !== 'undefined') {
            (0, clickstream_2.trackEvent)(logPayLoad, true);
        }
    };
    return AnalyticsInterface;
}());
exports.CommonAnalyticsInterface = new AnalyticsInterface();
exports.sendClickstreamLog = exports.CommonAnalyticsInterface.sendClickstreamLog;
